import { useCallback, useContext, useMemo, useState } from 'react';

import { MessageInfoVariant } from '../../MessageInfo';

import { UserFeatureToggles } from 'clients/UserClient/types';
import { MessageInfo } from 'components/ui/molecules/MessageInfo/MessageInfo';
import { useUpdateCurrentUserFeatureTogglesMutation } from 'hooks/shared/useUpdateCurrentUserFeatureTogglesMutation';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { useCurrentUserQuery } from 'shared/legacy/hooks/useCurrentUserQuery';
import { useStyles } from './HighQualityJobsMessageInfo.styles';

export const HighQualityJobsMessageInfo = () => {
  const { dictionary } = useContext(LocalizationContext);
  const classes = useStyles();
  const { data: currentUser, isLoading: isLoadingCurrentUser } = useCurrentUserQuery();
  const [isSelectHighQualityJobMessageLocalOpened, setIsSelectHighQualityJobMessageLocalOpened] = useState(true);
  const updateUserFeatureTogglesMutation = useUpdateCurrentUserFeatureTogglesMutation();

  const isSelectHighQualityJobMessageToggleClosed = useMemo<boolean>(() => {
    return (
      currentUser?.features?.find((f) => f.name === UserFeatureToggles.IS_SELECT_HIGH_QUALITY_JOB_MESSAGE_CLOSED)
        ?.enabled ?? false
    );
  }, [currentUser, isLoadingCurrentUser]);

  const closeMessageForever = useCallback(() => {
    setIsSelectHighQualityJobMessageLocalOpened(false);
    const togglesToUpdate = [
      {
        name: UserFeatureToggles.IS_SELECT_HIGH_QUALITY_JOB_MESSAGE_CLOSED,
        enabled: true,
        value: 'true',
      },
    ];

    updateUserFeatureTogglesMutation.mutate(togglesToUpdate);
  }, [updateUserFeatureTogglesMutation]);

  if (!isSelectHighQualityJobMessageLocalOpened || isSelectHighQualityJobMessageToggleClosed) {
    return null;
  }

  return (
    <div css={classes.root}>
      <MessageInfo
        message={dictionary.selectHighQualityJob}
        variant={MessageInfoVariant.Success}
        onRequestClose={closeMessageForever}
      />
    </div>
  );
};
